import React from "react";
import "./About_us.css";
import For_support from "../for-support/For_support";
import { Link } from "react-router-dom";
import About_us_banner from "./about_us_banner/About_us_banner";
import About_us_content from "./about_us_content/About_us_content";
import Vission_mission from "./vission_mission/Vission_mission";
import About_us_we_connect from "./about_us_we_connect/About_us_we_connect";

function About_us() {
  return (
    <>
      <About_us_banner />

      <About_us_content />

      <Vission_mission />

      <About_us_we_connect/>
      
      <div className="container mt-4">
        <section className="becobox">
          <div className="row">
            <div className="col-lg-9 my-auto">
              <p className="letsp">
                Let’s work together to{" "}
                <b>
                  grow your business faster and help you achieve — and exceed —
                  your goals.
                </b>
              </p>
            </div>
            <div className="col-lg-3 text-lg-end text-center">
              <Link to={"/registration"}>
                <button className="becobtn">Become a Partner</button>
              </Link>
            </div>
          </div>
        </section>
      </div>
      <For_support />
    </>
  );
}

export default About_us;
